// extracted by mini-css-extract-plugin
export default {"header":"SocialHeader_header__wTOrT","logo":"SocialHeader_logo__IKPgQ","socials":"SocialHeader_socials__8EfKF","icon":"SocialHeader_icon__hUKXH"};